import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import styles from './ConfirmationModal.module.scss'

import Button from '../../Button/Button'
import { useFormDirtyStore } from '@/store/useFormDirtyStore'

interface ConfirmationModalProps {
  title: string
  message: string
  onConfirm: () => void
  onClose: () => void
  isOpen: boolean
}

function ConfirmationModal(props: ConfirmationModalProps) {
  const { title, message, onConfirm, onClose, isOpen } = props
  const { t } = useTranslation()
  const resetIsDirty = useFormDirtyStore(s => s.reset)

  const handleOnConfirm = () => {
    resetIsDirty()
    onConfirm()
  }
  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose} size="small">
      <div className={styles.confirmationContainer}>
        <p className={`body-medium ${styles.confirmationSubHeader}`}>
          {message}
        </p>
        <p className={`body-medium ${styles.confirmationSubHeader}`}>
          {t('CONFIRMATION.SUB_TITLE.FIRST_PART')}
          <mark className="mark-orange">
            {t('CONFIRMATION.SUB_TITLE.SECOND_PART')}
          </mark>
          {t('CONFIRMATION.SUB_TITLE.THIRD_PART')}
        </p>
        <div className={styles.confirmationButtonContainer}>
          <Button
            color="primary"
            label={t('CONFIRMATION.CONFIRM')}
            variant="contained"
            onClick={handleOnConfirm}
          />
          <Button
            color="secondary"
            label={t('CONFIRMATION.CANCEL')}
            variant="contained"
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
